import angular from 'angular';

/**
 * @ngdoc overview
 * @name superuserModule.superuserDirectives
 * @description
 * # superuserModule.superuserDirectives
 * Module for managing the common directives.
 */
const superuserDirectives = angular.module('superuserModule.superuserDirectives', []);

/**
 * @ngdoc directive
 * @name superuserModule.superuserDirectives.directive:readWriteModules
 * @description
 * Directive for displaying read/write buttons for each modules
 */
superuserDirectives.directive('readWriteModules', () => {
    'use strict';

    return {
        restrict: 'EA',
        controller: ['$scope', 'SystemModules', function ($scope, SystemModules) {
            $scope.modules = SystemModules.getModules();
            $scope.advancedModules = SystemModules.getAdvancedModules();
            $scope.advanced = {};

            $scope.checkAll = {
                read: false,
                write: false
            };

            const checkToggleAll = () => {
                let readStatus = true;
                let writeStatus = true;

                angular.forEach($scope.module, (value) => {
                    if (!value.read && readStatus) {
                        readStatus = false;
                    }
                    if (!value.write && writeStatus) {
                        writeStatus = false;
                    }
                });
                $scope.checkAll = {
                    read: readStatus,
                    write: writeStatus
                };
            };

            $scope.toggleAdvanced = (option) => {
                if (option === 'products' && $scope.module.products.read === false && $scope.module.products.write === false) {
                    if (angular.isDefined($scope.module.orders)) {
                        $scope.module.orders.read = false;
                        $scope.module.orders.write = false;
                    }
                    if (angular.isDefined($scope.module.reviews)) {
                        $scope.module.reviews.read = false;
                        $scope.module.reviews.write = false;
                    }
                }
                if (option === 'dishes' && $scope.module.dishes.read === false && $scope.module.dishes.write === false) {
                    if (angular.isDefined($scope.module.provider)) {
                        $scope.module.provider.read = false;
                        $scope.module.provider.write = false;
                    }
                }
                // // Zaawansowane Opcje
                // if ($scope.module[option].advanced) {
                // $scope.module[option].write = true;
                // }

                checkToggleAll();
            };

            $scope.toggleAll = (type) => {
                const status = !$scope.checkAll[type];

                angular.forEach($scope.module, (value, key) => {
                    if (type === 'write' && status) {
                        $scope.module[key].read = status;
                        $scope.module[key].write = status;
                        $scope.checkAll.read = status;
                    } else if (type === 'write' && !status) {
                        $scope.module[key].write = status;
                    } else if (type === 'read' && !status) {
                        $scope.module[key].read = status;
                        $scope.module[key].write = status;
                        $scope.checkAll.write = status;
                    } else if (type === 'read' && status) {
                        $scope.module[key].read = status;
                    }
                });
            };

            $scope.$watch('module', () => {
                checkToggleAll();
            });
        }],
        templateUrl: 'views/superuser/modules/readWriteModules.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name superuserModule.superuserDirectives.directive:readWriteThead
 * @description
 * Directive for displaying read/write columns in table header <thead>
 */
superuserDirectives.directive('readWriteThead', () => {
    'use strict';

    return {
        restrict: 'EA',
        replace: true,
        controller: ['$scope', '$translate', 'SystemModules', function ($scope, $translate, SystemModules) {
            $scope.modules = SystemModules.getModules();

            $scope.getIconClass = (module) => {
                let iconClass = '';
                switch (module) {
                    case 'user':
                        iconClass = 'glyphicon glyphicon-user';
                        break;
                    case 'application':
                        iconClass = 'glyphicon glyphicon-phone';
                        break;
                    case 'section':
                        iconClass = 'glyphicon glyphicon-th-large';
                        break;
                    case 'users':
                        iconClass = 'glyphicon glyphicon-user';
                        break;
                    case 'messages':
                        iconClass = 'glyphicon glyphicon-envelope';
                        break;
                    case 'products':
                        iconClass = 'glyphicon glyphicon-picture';
                        break;
                    case 'reviews':
                        iconClass = 'fa fa-comments-o';
                        break;
                    case 'orders':
                        iconClass = 'glyphicon glyphicon-gift';
                        break;
                    case 'shops':
                        iconClass = 'glyphicon glyphicon-shopping-cart';
                        break;
                    case 'exhibitors':
                        iconClass = 'glyphicon glyphicon-credit-card';
                        break;
                    case 'news':
                        iconClass = 'fa fa-newspaper-o';
                        break;
                    case 'games':
                        iconClass = 'fa fa-gamepad';
                        break;
                    case 'dishes':
                        iconClass = 'fa fa-spoon';
                        break;
                    case 'notes':
                        iconClass = 'fa fa-list-alt';
                        break;
                    case 'levels':
                        iconClass = 'fa fa-map-marker';
                        break;
                    case 'meetings':
                        iconClass = 'fa fa-users';
                        break;
                    case 'ads':
                        iconClass = 'glyphicon glyphicon-volume-up';
                        break;
                    case 'gamifications':
                        iconClass = 'fa fa-futbol-o';
                        break;
                    case 'competitions':
                        iconClass = 'fa fa-bullseye';
                        break;
                    case 'provider':
                        iconClass = 'fa fa-spoon';
                        break;
                    case 'chats':
                        iconClass = 'fa fa-weixin';
                        break;
                    case 'maps':
                        iconClass = 'fa fa-map';
                        break;
                    case 'posts':
                        iconClass = 'fa fa-map';
                        break;
                    case 'cms_www':
                        iconClass = 'glyphicon glyphicon-th-large';
                        break;
                    case 'groups':
                        iconClass = 'fa fa-users';
                        break;
                    case 'files':
                        iconClass = 'glyphicon glyphicon-picture';
                        break;
                    case 'sso':
                        iconClass = 'fa fa-plug';
                        break;
                    case 'libraries':
                        iconClass = 'fa fa-file-text';
                        break;
                    case 'galleries':
                        iconClass = 'fa fa-file-image-o';
                        break;
                    case 'forms':
                        iconClass = 'fa fa-tasks';
                        break;
                    case 'polls':
                        iconClass = 'fa fa-check-square-o';
                        break;
                    case 'recipes':
                        iconClass = 'fa fa-spoon';
                        break;
                    case 'promotions':
                        iconClass = 'fa fa-percent';
                        break;
                    case 'newspapers':
                        iconClass = 'fa fa-newspaper-o';
                        break;
                    case 'evaluations':
                        iconClass = 'fa fa-newspaper-o';
                        break;
                    case 'banners':
                        iconClass = 'fa fa-file-image-o';
                        break;
                    case 'level_rebuses':
                        iconClass = 'fa fa-gamepad';
                        break;
                    case 'rebuses':
                        iconClass = 'fa fa-gamepad';
                        break;
                    case 'logs':
                        iconClass = 'fa fa-database';
                        break;
                    case 'price_lists':
                        iconClass = 'fa fa-calculator';
                        break;
                    case 'coupons':
                        iconClass = 'fa fa-credit-card';
                        break;
                    case 'integrations':
                        iconClass = 'fa fa-codepen';
                        break;
                    case 'users_www':
                        iconClass = 'fa fa-user';
                        break;
                    case 'data_management_users':
                        iconClass = 'fa fa-users';
                        break;
                    case 'categories':
                        iconClass = 'fa fa-book';
                        break;
                    case 'shopping_lists':
                        iconClass = 'glyphicon glyphicon-shopping-cart';
                        break;
                    case 'facets':
                        iconClass = 'fa fa-tags';
                        break;
                    case 'short_codes':
                        iconClass = 'fa fa-code';
                        break;
                    case 'themes':
                        iconClass = 'glyphicon glyphicon-bookmark';
                        break;
                }

                return iconClass;
            };

            $scope.getTooltip = (option) => {
                return $translate.instant(`MODULES.SYSTEM.COLUMNS.${option.toUpperCase()}`);
            };
        }],
        templateUrl: 'views/superuser/modules/readWriteThead.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name superuserModule.superuserDirectives.directive:readWriteTr
 * @description
 * Directive for displaying read/write row values in packages and roles tables
 */
superuserDirectives.directive('readWriteTr', () => {
    'use strict';

    return {
        restrict: 'EA',
        controller: ['$scope', 'AdminTable', 'SystemModules', ($scope, AdminTable, SystemModules) => {
            $scope.modules = SystemModules.getModules();

            $scope.getReadClass = AdminTable.getReadClass;
            $scope.getWriteClass = AdminTable.getWriteClass;
        }],
        templateUrl: 'views/superuser/modules/readWriteTr.tpl.html'
    };
});

export default superuserDirectives;
